import { ReactElement } from "react";
import { Typography } from "client/Components";
import { AnnouncementNotificationDataViewModel } from "client/Api/Notifications/notifications";

export type AnnouncementActivityProps = {
	data: AnnouncementNotificationDataViewModel;
};

export const AnnouncementActivity = (props: AnnouncementActivityProps): ReactElement => {
	const { data } = props;

	const title: string = prepareHubItemTitle(data.title);

	return (
		<>
			<Typography trackingId="announcement-title" weight="bold">
				{title}
			</Typography>.
		</>
	);
};

AnnouncementActivity.displayName = "AnnouncementActivity";

export function prepareHubItemTitle(title: string): string {
	if (!title) {
		return title;
	}

	title = title.trim();

	if (title.length === 0) {
		return title;
	}

	// remove trailing dot from title if exists
	// since there is already dot in notification template after title
	if (title.charAt(title.length - 1) === ".") {
		return title.slice(0, title.length - 1);
	}

	return title;
}